export default (countries: string[]) => {
  return countries?.map((value) => {
    return {
      label: value,
      value,
    };
  });
};
